import { log } from '@utils/logging';
import GeneralInfoStep from './GeneralInfoStep';
import SchedulingStep from './SchedulingStep';
import WeightClassStep from './WeightClassStep';
import WaiverStep from './WaiverStep';
import StripeLinkStep from '@molecules/StripeLinkStep';
import { EventForm } from './CreateEventUtils';
import { useFormContext } from 'react-hook-form';

export const GENERAL: number = 0;
export const SCHEDULING: number = 1;
export const CLASSES: number = 2;
export const WAIVER: number = 3;
export const STRIPE_STEP: number = 4;

interface StepProps {
    step: number;
}

export default function CreateEventSteps(props: StepProps) {
    const { step } = props;

    const { watch } = useFormContext<EventForm>();
    const [payToUserId] = watch(['payToUserId']);

    switch (step) {
        case GENERAL:
            return <GeneralInfoStep />;
        case SCHEDULING:
            return <SchedulingStep />;
        case CLASSES:
            return <WeightClassStep />;
        case WAIVER:
            return <WaiverStep />;
        case STRIPE_STEP:
            return <StripeLinkStep connectedAccountId={payToUserId} />;

        default:
            log(`Invalid CreateEvent step reached: ${step}`);
            return null;
    }
}
